// components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthService from '../../services/auth.service';

// Componente base per tutte le protezioni
const ProtectedRoute = ({ children, allowedRoles, redirectTo = '/patient/login' }) => {
  const authToken = AuthService.getToken();
  const user = AuthService.getUserFromStorage();

  console.log('Debug ProtectedRoute:', {
    authToken: !!authToken,
    user: user,
    userRole: user?.role,
    allowedRoles,
    redirectTo
  });

  // Verifica del token di autenticazione
  if (!authToken) {
    console.log('Redirect: Token di autenticazione non trovato');
    return <Navigate to={redirectTo} replace />;
  }

  // Verifica del ruolo
  if (!user || !allowedRoles.includes(user.role)) {
    console.log(`Redirect: Utente non autorizzato (ruolo: ${user?.role}, richiesti: ${allowedRoles})`);
    return <Navigate to={redirectTo} replace />;
  }

  // Se tutto è ok, renderizza i componenti figli
  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  redirectTo: PropTypes.string
};

// Componente specifico per Admin
export const ProtectedAdminRoute = ({ children }) => (
  <ProtectedRoute 
    allowedRoles={['admin']} 
    redirectTo="/admin/login"
  >
    {children}
  </ProtectedRoute>
);

// Componente specifico per Dottori
export const ProtectedDoctorRoute = ({ children }) => (
  <ProtectedRoute 
    allowedRoles={['therapist']} 
    redirectTo="/patient/login"
  >
    {children}
  </ProtectedRoute>
);

// Componente specifico per Pazienti
export const ProtectedPatientRoute = ({ children }) => (
  <ProtectedRoute 
    allowedRoles={['patient']} 
    redirectTo="/patient/login"
  >
    {children}
  </ProtectedRoute>
);

// Componente per rotte accessibili a più ruoli
export const ProtectedMultiRoleRoute = ({ children, allowedRoles }) => (
  <ProtectedRoute 
    allowedRoles={allowedRoles}
    redirectTo="/patient/login"
  >
    {children}
  </ProtectedRoute>
);

// Esportazioni per compatibilità
ProtectedAdminRoute.propTypes = {
  children: PropTypes.node.isRequired
};

ProtectedDoctorRoute.propTypes = {
  children: PropTypes.node.isRequired
};

ProtectedPatientRoute.propTypes = {
  children: PropTypes.node.isRequired
};

ProtectedMultiRoleRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ProtectedRoute;